import { initReactI18next } from "react-i18next";

import i18n from "i18next";

import { getStoredLanguage } from "@/utils/languageStorage";

import en from "./locales/en.json";
import es from "./locales/es.json";

const SUPPORTED_LANGUAGES = ["en", "es"] as const;

const initialLanguage = getStoredLanguage();

// Keep <html lang> in sync for screen readers and browser translation prompts.
const syncDocumentLanguage = (lng: string) => {
  document.documentElement.lang = lng;
};
syncDocumentLanguage(initialLanguage);
i18n.on("languageChanged", syncDocumentLanguage);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export { SUPPORTED_LANGUAGES };
export default i18n;
